var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"slider-overlay"},[_c('div',{staticClass:"slider-dialog"},[_c('div',{ref:"sliderContainer",staticClass:"slider-verification"},[_c('div',{attrs:{"id":"captcha-box"}}),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v("\n        加载中...\n      ")]):_vm._e()])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-311176fe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SliderVerification.vue
// module id = null
// module chunks = 